<template>
  <div class="customHeader">
    <center>
      <img class="img-fluid logo" src="@/assets/logo.webp" alt="">
      <br>
      <button @click="this.$router.push('/watch')" class="btn watchBTN">WATCH AOTCHRON EPISODES</button>
    </center>
    <a href="#menu" class="pfeil"></a>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.customHeader {
  width: 100%;
  height: 100vh;
  background: url("../assets/background.webp");
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.logo {
  max-height: 24rem;
}

.watchBTN {
  margin-top: 14%;
  background: rgb(183, 220, 247);
  background: linear-gradient(90deg, rgb(183, 213, 247) 0%, rgb(141, 190, 236) 50%, rgba(183, 220, 247, 1) 100%);
  border: 1px solid white;
  box-shadow: 0 0 10px white;
  font-weight: bold;
  padding: 1rem 2rem 1rem 2rem;
  border-radius: 0px;
  opacity: 0.8;
  font-size: 1.5rem;
  transition: all 0.2s ease;
}

.watchBTN:hover {
  transform: scale(1.15);
}

@media only screen and (max-width: 800px) {
  .watchBTN {
    font-size: 1rem;

  }
}

.pfeil {
  position: absolute;
  right: 5rem;
  bottom: 2rem;
  background: transparent;
  /* Transparentes Hintergrund */
  border: none;
  /* Kein Rand */
  padding: 10px 20px;
  /* Abstand zwischen Text und Rand */
  transform-origin: center bottom;
  animation: bounce 2s ease-in-out infinite;
}

.pfeil::after {
  content: "";
  /* Leere Inhalte für den Pfeil */
  position: absolute;
  /* Absolut positioniert */
  bottom: -5px;
  /* Unter dem Button */
  left: 50%;
  /* In der Mitte */
  transform: translateX(-50%);
  /* Zentriert */
  border-width: 4rem 4rem 0;
  /* Breite des Pfeils */
  border-style: solid;
  /* Solid Style */
  border-color: rgb(255, 255, 255) transparent transparent;
  /* Farbe des Pfeils */
}

@keyframes bounce {
  0% {
    transform: translateY(0);
    /* Anfangszustand ohne Translation */
  }

  50% {
    transform: translateY(-2.5rem);
    /* Translate um -10px in Y-Richtung */
  }

  100% {
    transform: translateY(0);
    /* Zurück zum Anfangszustand */
  }
}</style>